import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import * as i0 from "@angular/core";
import * as i1 from "../services/auth.service";
import * as i2 from "@angular/router";
import * as i3 from "@angular/material/snack-bar";
export class AdminGuard {
    constructor(auth, router, matSnackBar) {
        this.auth = auth;
        this.router = router;
        this.matSnackBar = matSnackBar;
    }
    canActivate(route, state) {
        if (!this.auth.isLoggedIn()) {
            this.router.navigate(['login']);
            return false;
        }
        const hasMedicalRole = this.auth.hasRole('Doctor') || this.auth.hasRole('Demographic') || this.auth.hasRole('Dispensary');
        // Si tiene rol médico (Doctor, Demographic o Dispensary ), permitir acceso
        if (hasMedicalRole) {
            return true;
        }
        // Si es técnico interno, permitir acceso
        if (this.auth.hasRole('tecnico interno')) {
            return true;
        }
        // Si es proponente sin rol médico, redirigir a transactions
        if (this.auth.hasRole('Proponente')) {
            this.router.navigate(['/transactions']);
            return false;
        }
        // Si no tiene ninguno de los roles permitidos, logout
        this.matSnackBar.open('Hubo un problema con el usuario', 'OK', {
            duration: 3000
        });
        this.auth.logout();
        return false;
    }
    canActivateChild(route, state) {
        return this.canActivate(route, state);
    }
}
AdminGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AdminGuard_Factory() { return new AdminGuard(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.MatSnackBar)); }, token: AdminGuard, providedIn: "root" });
